import React, { useState } from 'react'
import MasterData from './MasterData'

const MasterDataLayout = () => {
  return (
    <div className="container">
      <MasterData />
    </div>
  )
}

export default MasterDataLayout
